import { useState } from "react"
import { TooltipButton } from "@/v2-backoffice-client/components/button"
import Badge from "@/v2-backoffice-client/components/badge"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"
import MigrationCenterDialog from "@/v2-backoffice-client/tenant/migration/center/MigrationCenterDialog"

export type TenantMigrateManyButtonProps = {
  tenants: TenantFragment[]
  onCompleted?(): void
}

// Opens the Migration Center for a tenant-table selection (FUS-927): the
// selected teams grouped by customer with live per-member status and the
// aggregate progress bar; the wave itself is sent from inside the dialog.
function TenantMigrateManyButton(props: TenantMigrateManyButtonProps) {
  const { tenants, onCompleted } = props
  const [open, setOpen] = useState(false)

  return (
    <>
      <TooltipButton
        className="relative"
        isStacked
        iconSrc="key"
        variant="ghost"
        content={`Review and send Fusion login activations for ${tenants.length} team(s)`}
        disabled={!tenants.length}
        onClick={() => {
          setOpen(true)
        }}
      >
        Fusion
        <Badge
          className="absolute top-0 right-0 text-[8px] rounded-full"
          variant="neutral"
          size="tiny"
        >
          {tenants.length}
        </Badge>
      </TooltipButton>

      <MigrationCenterDialog
        open={open}
        onOpenChange={setOpen}
        selection={{ kind: "tenants", tenants }}
        onCompleted={onCompleted}
      />
    </>
  )
}

export default TenantMigrateManyButton
